import { getUrlKey, isMobile } from "@/util/util";

export default {
    data() {
        return {
            red: 50,
            blue: 50,
            count_down: '',    // 倒计时
            params: {},
            id: 0,
            info: {},
            data: {},
            p: 1,
            comment_list: [],
            flag: false,
            timer: '',
            selected: -1,            // 选择的明星
            is_login: false,
            status: 0
        }
    },

    watch:{
        '$route':'getId',
    },



    created() {
        this.id = getUrlKey('id',location.href);
        this.is_login = this.$isLogin();
        if(isMobile()) {
            location.href = this.$link + '/topic/detail?id=' + this.id
        }
        this.getRightList();
        this.getInfo();
    },

    mounted() {
        this.timer = setInterval(() => {
            if(this.flag) {
                clearInterval(this.timer);
            }
            this.countDown(this.data.end_time)
        },1000)
    },

    methods: {

        openIndex() {
            this.$router.push({
                name: 'topic'
            })
        },

        openPop() {
            this.$MessageBox.confirm(
                '参与话题需要在手机APP内操作，点击确定将跳转APP下载页',
                '提示').then(res => {
                this.$router.push({
                    name: 'download'
                })
            })
        },

        getId() {
            this.id = getUrlKey('id',location.href);
            this.getInfo();
        },

        // 倒计时
        countDown(endtime) {
            const end_time = new Date(endtime).getTime();
            // console.log(end_time)
            // const  end_time = count * 1000;
            const now_time = new Date().getTime();
            let left_time = parseInt((end_time-now_time)/1000);
            if(left_time <= 0) {
                this.flag = true;
                this.count_down = '已结束'
                return;
            };
            let d = this.format(parseInt(left_time / 60 / 60 / 24));
            let h = this.format(parseInt(left_time / 60 / 60) % 24);
            let m = this.format(parseInt(left_time / 60) % 60);
            let s = this.format(parseInt(left_time % 60))
            // console.log(s)
            this.count_down = d + ':' + h + ':' + m + ':' + s;
        },

        format(time) {
            return time < 10 ? '0'+time : time
        },

        loadInfo() {
            this.p ++;
            this.getInfo();
        },

        changeSelect(item,index) {
            this.selected = index;
        },

        openLogin() {
            this.$parent.$children[0].openLoginPop();
        },

        // 获取话题详情
        getInfo() {
            // if(this.status === 2) {
            //     return;
            // }
            this.$post('api.php/Activity/topicInfo',{
                token: this.$getToken(),
                topic_id: this.id || this.id,
                p: this.p
            }).then(res => {
                if(res.status === 1) {
                    this.data = res.data || {};
                    let name = this.data.type === 1 ? '热议' : this.data.type === 2 ? '投票' : '观点PK';
                    document.title = this.data.title + '-' + name + '- 文娱中国';
                    let sum = this.data.red_support + this.data.blue_support;
                    this.red = (this.data.red_support / sum) * 100;
                    this.blue = (this.data.blue_support / sum) * 100;
                    if(this.p === 1) {
                        this.comment_list = this.data.comment_list || [];
                    }else {
                        let arr = this.data.comment_list || [];
                        this.comment_list = this.comment_list.concat(arr);
                    }

                    if(this.data.comment_count === this.comment_list.length) {
                        this.status = 2;
                    }else if(this.data.comment_count == 0) {
                        this.status = 0;
                    }else {
                        this.status = 1;
                    }
                }
            })
        },


        initCommentList() {
            this.p = 1;
            this.status = 0;
            this.comment_list = [];
            this.getInfo();
        },


        // 获取右侧列表信息
        getRightList() {
            this.$post('api.php/Home/topicRight').then(res => {
                if(res.status == 1) {
                    this.info = res.data || {};
                }
            })
        }
    }
}
